// extracted by mini-css-extract-plugin
export default {"proj":"project_proj__CRuwM","proj_title":"project_proj_title__zUQbN","proj_name":"project_proj_name__i6lEj","proj_icon":"project_proj_icon__Dcd9a"};